module.exports = __webpack_public_path__ + "media/OMMAX-Digital-Career.a9b572d4.mp4";